
 
 const isMobile = window.innerWidth < 768;
 const s = {
    page: {
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      background: "#f1f5f9",
      fontFamily: "'Inter', sans-serif",
      position: "relative",
      overflow: "hidden",
      fontSize: 20,
    },
    scrollContainer: {
      flex: 1,
      overflowY: "auto",

      padding: isMobile ? "12px 10px 100px 10px" : "30px 40px 120px 40px",

      width: "100%",
      boxSizing: "border-box",
    },

    content: {
      display: "flex",
      gap: 16,
      flexDirection: isMobile ? "column" : "row",
      width: "100%",
    },
    questionCard: {
      background: "#fff",
      padding: isMobile ? 14 : 32,
      borderRadius: 18,
      boxShadow: "0 4px 20px rgba(0,0,0,.05)",

      width: "100%",
      maxWidth: "100%",
    },

    option: {
      padding: "16px 20px",
      marginBottom: 12,
      borderRadius: 12,
      border: "2px solid",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: 15,
      fontWeight: 600,
    },
    detailBox: { marginTop: 25 },
    detailTitle: {
      marginBottom: 10,
      color: "#475569",
      fontSize: 13,
      fontWeight: "700",
    },
    codeBlock: {
      // background: "#0f172a",
      color: "#0f172a",
      padding: "16px",
      borderRadius: 12,
      fontSize: 13,
      fontFamily: "'Fira Code', monospace",
       overflow:"hidden",
                     whiteSpace:"pre-wrap",//allow line wrap
                     wordBreak:"break-word"//for breaking the word to prevent to 
                     //go out of the box  
    },
    terminalCard: {
      background: "#0f172a",
      borderRadius: 18,
      padding: isMobile ? 12 : 20,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      minHeight: isMobile ? "400px" : "500px",
    },
    termRight: {
      width: "45%",
      height: "calc(100vh - 160px)", // nav + padding adjust
      position: "sticky",
      top: -3,
    },
    termRightMobile: {
      width: "100%",
      height: "auto",
      position: "relative",
    },

    termFull: {
      position: "fixed",
      inset: 0,
      zIndex: 999,
      borderRadius: 0,
      pointerEvents: "auto", // ⭐ click pass-through
    },
    termControls: { display: "flex", gap: 12, marginBottom: 15 },
    iconBtn: {
      background: "#1e293b",
      border: "none",
      color: "#fff",
      padding: 8,
      borderRadius: 6,
      cursor: "pointer",
    },
    textarea: {
      width: "100%",
      minHeight: 250,
      background: "#1e293b",
      color: "#f8fafc",
      border: "1px solid #334155",
      borderRadius: 12,
      padding: 16,
      fontFamily: "'Fira Code', monospace",
      fontSize: 14,
      outline: "none",
    },
    runBtn: {
      marginTop: 15,
      background: "#10b981",
      color: "#fff",
      border: "none",
      padding: "12px 24px",
      borderRadius: 10,
      cursor: "pointer",
      fontWeight: "bold",
      display: "flex",
      gap: 8,
      alignItems: "center",
    },
    outputContainer: { marginTop: 20 },
    output: {
      background: "#1e293b",
      padding: 15,
      borderRadius: 10,
      color: "#2dd4bf",
      fontSize: 13,
      minHeight: 60,
    },
    // --- YE HAI FIXED NAVIGATION KI STYLING ---
    navFixed: {
      position: "fixed", // Fixed position inside relative parent
      bottom: 0,
      left: 0,
      right: 0,
      background: "rgba(241, 245, 249, 0.8)", // Glassmorphism effect
      backdropFilter: "blur(10px)",
      padding: "20px 40px",
      borderTop: "1px solid #e2e8f0",
      zIndex: 1000,
    },
    navContent: {
      maxWidth: "1200px",
      margin: "0 auto",
      background: "#fff",
      padding: "12px 30px",
      borderRadius: "100px", // Capsule shape
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    },
    navBtn: {
      padding: "10px 25px",
      borderRadius: "50px",
      border: "1px solid #e2e8f0",
      background: "#fff",
      cursor: "pointer",
      fontWeight: "700",
      display: "flex",
      alignItems: "center",
      gap: 8,
      transition: "0.3s",
    },
    center: {
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    infoBar: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1.2fr 1fr",
      gap: 10,
      width: "100%",
    },

    infoChip: {
      padding: window.innerWidth < 600 ? "4px 8px" : "6px 10px",
      fontSize: window.innerWidth < 600 ? "11px" : "12px",
      borderRadius: "999px",
      fontWeight: 500,
      textAlign: "center",
      maxWidth: "100%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "anywhere",
      lineHeight: "1.2",
    },

    statusRow: {
      display: "flex",
      gap: 12,
      flexWrap: "wrap",
      justifyContent: "flex-start",
    },

    statusBox: {
      border: "1px solid #e5e7eb",
      borderRadius: 12,
      padding: window.innerWidth < 600 ? "8px 10px" : "10px 14px",
      background: "#fff",
      flex: window.innerWidth < 768 ? "1 1 48%" : "1 1 160px",
    },

    statusTitle: {
      fontSize: 13,
      marginBottom: 6,
    },
    radioRow: {
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontSize: 12,
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: "50%",
    },
    metaRow: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr",
      gap: 12,
      width: "100%",
    },

    infoItem: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      minWidth: 0, // 🔥 VERY IMPORTANT for grid overflow
    },

    infoLabel: {
      fontSize: 11,
      fontWeight: 700,
      color: "#64748b",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    questionText: {
      fontSize: "10px",
      lineHeight: "1",
      wordBreak: "break-word",
    },
    qNavSingleBox: {
      display: "flex",
      alignItems: "center",
      gap: window.innerWidth < 600 ? 6 : 12,
      padding: window.innerWidth < 600 ? "6px 10px" : "8px 16px",
      borderRadius: 30,
      background: "#f1f5f9",
      border: "1px solid #e2e8f0",
      width: "fit-content",
      flexWrap: "wrap",
    },

    qNavPrev: {
      color: "#fff",
      fontWeight: 800,
      fontSize: 13,
      borderRadius: 20,
      background: "#0284c7",
      padding: "4px 10px",
    },

    qNavCurrent: {
      background: "#6366f1",
      color: "#fff",
      borderRadius: 20,
      padding: window.innerWidth < 600 ? "2px 8px" : "4px 10px",
      fontWeight: 800,
      fontSize: window.innerWidth < 600 ? 12 : 13,
    },

    qNavNext: {
      color: "#fff",
      fontWeight: 800,
      fontSize: 13,
      borderRadius: 20,
      background: "#16a34a",
      padding: "4px 10px",
    },
    instructionBox: {
      background: "#f9fafb",
      border: "1px solid #e5e7eb",
      borderLeft: "5px solid #6366f1", // highlight strip
      borderRadius: 10,
      padding: "14px 16px",
      marginTop: 10,
      fontSize: 10,
      color: "#1f2933",
      boxShadow: "0px 2px 6px rgba(0,0,0,0.06)",
    },
    userBar: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: 16,
      position: "relative",
    },

    userBox: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "8px 14px",
      background: "#fff",
      borderRadius: 999,
      boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
      cursor: "pointer",
    },

    avatar: {
      width: 36,
      height: 36,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #6366f1, #22c55e)",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 800,
      fontSize: 14,
    },

    userInfo: {
      display: "flex",
      flexDirection: "column",
      lineHeight: 1.2,
    },

    userName: {
      fontSize: 13,
      fontWeight: 700,
      color: "#1e293b",
      maxWidth: 140,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    userEmail: {
      fontSize: 11,
      color: "#64748b",
      maxWidth: 140,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    dropdown: {
      position: "absolute",
      top: "110%",
      right: 0,
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
      overflow: "hidden",
      minWidth: 160,
      zIndex: 3000,
    },

    dropdownItem: {
      padding: "12px 16px",
      fontSize: 13,
      fontWeight: 600,
      cursor: "pointer",
      borderBottom: "1px solid #f1f5f9",
    },
  };

export default s;